import { api, queryString, type Items } from '@sentinel/web-core';
import type {
  Place,
  PlaceCreate,
  PlaceImportReport,
  PlaceKind,
  PlaceSuggestion,
  Territory,
} from '@sentinel/shared';

/** The organization's places (ADR 0032): suggestions while typing, OpenStreetMap on Enter, the
 *  list managed in Impostazioni. */
export const placeEndpoints = {
  suggest: (q: string) => api<Items<PlaceSuggestion>>(`/places/suggest${queryString({ q })}`),
  osm: (q: string, lang: 'it' | 'en') =>
    api<Items<PlaceSuggestion>>(`/places/osm${queryString({ q, lang })}`),
  territory: () => api<{ territory: Territory | null }>('/places/territory'),
  list: (params: { q?: string; kind?: PlaceKind }) =>
    api<Items<Place>>(`/places${queryString(params)}`),
  create: (body: PlaceCreate) => api<Place>('/places', { method: 'POST', body }),
  update: (id: string, body: Partial<PlaceCreate>) =>
    api<Place>(`/places/${id}`, { method: 'PATCH', body }),
  remove: (id: string) => api<void>(`/places/${id}`, { method: 'DELETE' }),
  import: (body: { format: 'csv' | 'geojson'; content: string }) =>
    api<PlaceImportReport>('/places/import', { method: 'POST', body }),
};
